import type { AiDraftsTranslation } from './types';

export const aiDraftsHi: AiDraftsTranslation = {
  title: 'समीक्षा के लिए AI ड्राफ़्ट',
  by: '{{name}} (AI) ने सार्वजनिक स्रोतों से लिखा। आपकी मंज़ूरी तक कुछ नहीं भेजा जाता।',
  textLabel: 'ड्राफ़्ट जवाब',
  badge: 'ड्राफ़्ट तैयार',
  approve: 'मंज़ूर करें और भेजें',
  edit: 'बदलें',
  editLabel: 'भेजने से पहले ड्राफ़्ट बदलें',
  sendEdited: 'बदला हुआ भेजें',
  cancelEdit: 'बदलाव रद्द करें',
  emptyEdit: 'भेजने से पहले जवाब लिखें, या बदलाव रद्द करें।',
  reject: 'अस्वीकार करें',
  sent: 'ड्राफ़्ट आपकी ओर से भेजा गया।',
  editedSent: 'आपका बदला हुआ ड्राफ़्ट भेजा गया।',
  notSent: 'नहीं भेजा गया। आपका जवाब अभी न भेजे गए संदेशों के साथ रखा है: जवाब वाले बॉक्स से दोबारा कोशिश करें।',
  rejected: 'ड्राफ़्ट अस्वीकार किया गया। कुछ नहीं भेजा गया।',
  closedBy: '{{name}} इस ड्राफ़्ट पर पहले ही फ़ैसला कर चुके हैं।',
  closed: 'यह ड्राफ़्ट अब इस बातचीत के लायक नहीं है।',
  rejectDialog: {
    title: 'यह ड्राफ़्ट अस्वीकार करें',
    description:
      'ग्राहक को कुछ नहीं भेजा जाता। आपकी वजह ड्राफ़्ट के साथ रखी जाती है ताकि असिस्टेंट बेहतर हो सके।',
    reason: 'आप इसे क्यों अस्वीकार कर रहे हैं?',
    reasonMissing: 'कोई वजह चुनें।',
    note: 'नोट',
    submit: 'ड्राफ़्ट अस्वीकार करें',
    reasons: {
      inaccurate: 'यह ग़लत है',
      incomplete: 'कुछ छूट गया है',
      wrong_tone: 'लहजा ठीक नहीं है',
      not_needed: 'जवाब की ज़रूरत नहीं',
      other: 'कुछ और',
    },
  },
  ended: {
    approved: '{{name}} ने यह ड्राफ़्ट भेजा।',
    edited: '{{name}} ने इस ड्राफ़्ट का बदला हुआ रूप भेजा।',
    rejected: '{{name}} ने यह ड्राफ़्ट अस्वीकार किया: {{reason}}।',
    customer_wrote: 'ड्राफ़्ट बदल दिया गया: ग्राहक ने फिर लिखा।',
    owner_changed: 'ड्राफ़्ट अलग रखा गया: बातचीत किसी और को चली गई।',
    answered: 'ड्राफ़्ट अलग रखा गया: किसी ने ख़ुद जवाब दिया।',
    replaced: 'एक नए ड्राफ़्ट ने इसकी जगह ली।',
    resolved: 'ड्राफ़्ट अलग रखा गया: बातचीत हल हो गई।',
    dismiss: 'हटाएँ',
  },
};
